export default __webpack_public_path__ + "static/delta_lake-d62b06b6698312a47777755024866d90.png";